import { axiosConfig } from '../api/axios-config.js'

// AI 對話測試 API
export const aiChat = {
  // 發送聊天訊息
  chat: (data, token) => axiosConfig.post('/api/ai/chat', data, token),

  // 模擬 Line 聊天
  simulateLine: (data, token) => axiosConfig.post('/api/ai/chat/simulate-line', data, token),

  // 暫停 AI
  pause: (data, token) => axiosConfig.post('/api/ai/pause', data, token),

  // 取得暫停狀態
  pauseStatus: (params, token) => {
    const config = { ...token }
    if (params) config.params = params
    return axiosConfig.get('/api/ai/pause/status', config)
  }
}